import styled from "styled-components";
import { SuccessButton } from "../styles/button";
import { Modal } from "../components/modal";
import { JSX, useState } from "react";
import { FormStyle, InputStyle, TextArea } from "../styles/form";
import { translate, Translate } from "../components/translate";
import { useLanguage } from "../stores/language_store";

export function ContactForm() {
  const [modalContent, setModalContent] = useState<JSX.Element>();
  const [lastName, setLastName] = useState<string>();
  const [firstName, setFirstName] = useState<string>();
  const [email, setEmail] = useState<string>();
  const [textArea, setTextArea] = useState<string>();
  const language = useLanguage();

  const openModal = () =>
    setModalContent(
      <ModalContainer>
        <OutputModal>
          <Translate value="last_name" /> : {lastName}
        </OutputModal>
        <OutputModal>
          <Translate value="first_name" /> : {firstName}
        </OutputModal>
        <OutputModal>Email : {email}</OutputModal>
        <OutputModal>
          <Translate value="text" /> : {textArea}
        </OutputModal>
      </ModalContainer>
    );
  const closeModal = () => setModalContent(undefined);

  return (
    <>
      <FormStyle>
        <Title>
          <Translate value="contact_us" />
        </Title>
        <InputStyle
          type="text"
          placeholder={translate("last_name", language)}
          autoComplete="family-name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <InputStyle
          type="text"
          placeholder={translate("first_name", language)}
          autoComplete="given-name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <InputStyle
          type="email"
          placeholder="Email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextArea
          placeholder={translate("message", language)}
          value={textArea}
          onChange={(e) => setTextArea(e.target.value)}
        ></TextArea>
        <SuccessButton
          onClick={(e) => {
            e.preventDefault();
            openModal();
          }}
        >
          <Translate value="send" />
        </SuccessButton>
      </FormStyle>
      <Modal onClose={closeModal}>{modalContent}</Modal>
    </>
  );
}

const ModalContainer = styled.div`
  background-color: white;
  padding: 80px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-radius: 10px;
`;

const OutputModal = styled.div`
  border: powderblue;
`;

const Title = styled.h1`
  @media (max-width: 1024px) {
    font-size: 25px;
  }
`;
